import React from 'react'

import Intro from './intro/templates/template-intro'
import { t } from 'src/common/i18n'

import CallIcon from 'src/assets/images/monitoring/icons/call.png'
import TriggerIcon from 'src/assets/images/monitoring/icons/trigger.png'
import CarIcon from 'src/assets/images/monitoring/icons/car.png'
import ForgivnessIcon from 'src/assets/images/monitoring/icons/forgiveness.png'
import HomeIcon from 'src/assets/images/monitoring/icons/home.png'
import TapIcon from 'src/assets/images/monitoring/icons/tap.png'

// import work1 from 'src/assets/images/monitoring/how_it_work_1.png'
import work2 from 'src/assets/images/monitoring/how_it_work_2.png'
import work3 from 'src/assets/images/monitoring/how_it_work_3.png'
import work4 from 'src/assets/images/monitoring/how_it_work_4.png'
import work5 from 'src/assets/images/monitoring/how_it_work_5.png'

import Sec5 from 'src/assets/images/monitoring/5sec.png'
import Sec30 from 'src/assets/images/monitoring/30sec.png'
import Sec60 from 'src/assets/images/monitoring/60sec.png'

import Reason1 from 'src/assets/images/monitoring/reason_1.png'
import Reason2 from 'src/assets/images/monitoring/reason_2.png'
import Reason3 from 'src/assets/images/monitoring/reason_3.png'

const plans = [
  {
    id: 'plus',
    title: t('protection_plan_h5_price_plus_name'),
    display_price: t('protection_plan_h5_price_plus_month'),
    dispatch: t('protection_plan_h5_price_plus_info')
  },
  {
    id: 'basic',
    title: t('protection_plan_h5_price_basic_name'),
    display_price: t('protection_plan_h5_price_basic_month'),
    dispatch: t('protection_plan_h5_price_basic_info')
  }
]

const benifits = {
  plus: [
    { icon: CallIcon, description: t('protection_plan_h5_plus_benefit1') },
    { icon: TriggerIcon, description: t('protection_plan_h5_plus_benefit2') },
    { icon: CarIcon, description: t('protection_plan_h5_plus_benefit3') },
    { icon: ForgivnessIcon, description: t('protection_plan_h5_plus_benefit4') },
    // { icon: HomeIcon, description: t('protection_plan_h5_plus_benefit5') },
  ],
  basic: [
    { icon: CallIcon, description: t('protection_plan_h5_basic_benefit1') },
    { icon: TapIcon, description: t('protection_plan_h5_basic_benefit2') },
    { icon: CarIcon, description: t('protection_plan_h5_basic_benefit3') },
    { icon: HomeIcon, description: t('protection_plan_h5_basic_benefit4') },
  ]
}

const reasons = {
  title: 'Why You Need the Plan In Addition to Calling 911',
  list: [
    {
      icon: Reason1,
      description: 'Get accurate location data'
    },
    {
      icon: Reason2,
      description: 'Get other vital information about your emergency before the police ask'
    },
    {
      icon: Reason3,
      description: "Supports you when you can't or don't know that you need to call for help"
    }
  ]
}

const htws = {
  plus: [
    {
      icon: work4,
      title: t('protection_plan_h5_htw_plus1_title'),
      description: t('protection_plan_h5_htw_plus1_desc')
    },
    {
      icon: work2,
      title: t('protection_plan_h5_htw_plus2_title'),
      description: t('protection_plan_h5_htw_plus2_desc')
    },
    {
      icon: work3,
      title: t('protection_plan_h5_htw_plus3_title'),
      description: t('protection_plan_h5_htw_plus3_desc')
    }
  ],
  basic: [
    {
      icon: work4,
      title: t('protection_plan_h5_htw_basic1_title'),
      description: t('protection_plan_h5_htw_basic1_desc')
    },
    {
      icon: work5,
      title: t('protection_plan_h5_htw_basic2_title'),
      description: t('protection_plan_h5_htw_basic2_desc')
    },
    {
      icon: work2,
      title: t('protection_plan_h5_htw_basic3_title'),
      description: t('protection_plan_h5_htw_basic3_desc')
    },
    {
      icon: work3,
      title: t('protection_plan_h5_htw_basic4_title'),
      description: t('protection_plan_h5_htw_basic4_desc')
    }
  ]
}

const actions = [
  {
    icon: Sec5,
    title: t('protection_plan_h5_priority_5s'),
    description: t('protection_plan_h5_priority_5s_desc')
  },
  {
    icon: Sec30,
    title: t('protection_plan_h5_priority_30s'),
    description: t('protection_plan_h5_priority_30s_desc')
  },
  {
    icon: Sec60,
    title: t('protection_plan_h5_priority_60s'),
    description: t('protection_plan_h5_priority_60s_desc')
  }
]

const comparisons = [
  {
    description: t('protection_plan_h5_comparsion1'),
    info: t('protection_plan_h5_comparsion1_note'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion2'),
    info: t('protection_plan_h5_comparsion2_note'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion3'),
    info: t('protection_plan_h5_comparsion3_note'),
    plus: true,
    basic: false,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion4'),
    info: t('protection_plan_h5_comparsion4_note'),
    plus: true,
    basic: false,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion5'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion6'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion7'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion8'),
    info: t('protection_plan_h5_comparsion8_note'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion9'),
    info: t('protection_plan_h5_comparsion9_note'),
    plus: true,
    basic: true,
    noplan: false
  },
  {
    description: t('protection_plan_h5_comparsion10'),
    info: t('protection_plan_h5_comparsion10_note'),
    plus: true,
    basic: false,
    noplan: false
  }
]

const faqs = [
  [
    t('protection_plan_h5_q1'),
    t('protection_plan_h5_a1'),
  ],
  [
    t('protection_plan_h5_q2'),
    t('protection_plan_h5_a2'),
  ],
  [
    t('protection_plan_h5_q3'),
    t('protection_plan_h5_a3'),
  ],
  [
    t('protection_plan_h5_q4'),
    t('protection_plan_h5_a4'),
  ],
  [
    t('protection_plan_h5_q5'),
    t('protection_plan_h5_a5'),
  ],
  [
    t('protection_plan_h5_q6'),
    t('protection_plan_h5_a6'),
  ],
  [
    t('protection_plan_h5_q7'),
    t('protection_plan_h5_a7'),
  ],
  [
    t('protection_plan_h5_q8'),
    t('protection_plan_h5_a8'),
  ],
  [
    t('protection_plan_h5_q9'),
    t('protection_plan_h5_a9'),
  ],
  [
    t('protection_plan_h5_q10'),
    t('protection_plan_h5_a10'),
  ],
]

const CONFIG = {
  title: t('protection_plan_h5_title'),
  reasons,
  plans,
  benifits,
  htws,
  actions,
  comparisons,
  faqs
}

export default function IntroPage() {
  return (
    <Intro
      config={CONFIG}
      showSwiperBanner={true}
      page="intro"
    />
  )
}
